import React, { useState, useEffect } from 'react';

function compare(a, b, locale) {
    if (a === false) {
        a = null;
    }
    if (b === false) {
        b = null;
    }
    if (a === b) {
        return 0;
    }
    // nulls sort after anything else
    else if (a === null) {
        return 1;
    }
    else if (b === null) {
        return -1;
    }
    // otherwise, if we're ascending, lowest sorts first
    else if (locale === "asc") {
        return a < b ? -1 : 1;
    }
    // if descending, highest sorts first
    else {
        return a < b ? 1 : -1;
    }

};
export const customSortRow = (cellA, cellB, sortDirection, sortStates, locale, headers) => {
    cellA = cellA !== "undefined" && cellA && cellA.substr(0, cellA.indexOf("/")) ? cellA.substr(0, cellA.indexOf("/")) : null;
    //console.log(cellA, cellB);
    //cellA & cellB are 2 rows for comparision
    let hours1 = cellA !== null && cellA.substr(0, cellA.indexOf("Hours")) ? cellA.substr(0, cellA.indexOf("Hours")) : 0;
    if (cellA !== null && cellA.substring(0, cellA.indexOf("Seconds")) !== "") {
        hours1 = cellA !== null && cellA.substr(0, cellA.indexOf("Seconds")) ? cellA.substr(0, cellA.indexOf("Seconds")) : 0;
    }
    if (cellA !== null && cellA.substring(0, cellA.indexOf("Day")) !== "") {
        hours1 = cellA !== null && cellA.substr(0, cellA.indexOf("Day")) ? cellA.substr(0, cellA.indexOf("Day")) : 0;
        hours1 = hours1 * 24;
    }
    let minutes1;
    if (cellA !== null && cellA && cellA.substr(0, cellA.indexOf("Hours")) === "") {
        minutes1 = cellA && cellA.substr(0, cellA.indexOf("Minutes"));
    }
    else {
        minutes1 = cellA !== null && cellA.substring(0, cellA.indexOf("Minutes")) !== "" && hours1 !== null ? cellA.trim().split("Hours").pop() : null;
    }
    let hourstoInt = (hours1 !== "" && parseInt(hours1 * 60));
    let minutestoInt = (minutes1 && minutes1 !== "" ? parseInt(minutes1) : 0);
    let total1 = hours1 !== null && hourstoInt !== null && minutestoInt !== null ? parseInt(hourstoInt) + parseInt(minutestoInt) : null;
    cellB = cellB !== "undefined" && cellB !== null && cellB && cellB.substr(0, cellB.indexOf("/")) ? cellB.substr(0, cellB.indexOf("/")) : null;

    let hours2 = cellB !== null && cellB && cellB.substr(0, cellB.indexOf("Hours")) ? cellB.substr(0, cellB.indexOf("Hours")) : 0;
    if (cellB !== null && cellB.substring(0, cellB.indexOf("Seconds")) !== "") {
        hours2 = cellB !== null && cellB.substr(0, cellB.indexOf("Seconds")) ? cellB.substr(0, cellB.indexOf("Seconds")) : 0;
    }
    if (cellB !== null && cellB.substring(0, cellB.indexOf("Day")) !== "") {
        hours2 = cellB !== null && cellB.substr(0, cellB.indexOf("Day")) ? cellB.substr(0, cellB.indexOf("Day")) : 0;
        hours2 = hours2 * 24;
    }
    let minutes2;
    if (cellB !== null && cellB && cellB.substr(0, cellB.indexOf("Hours")) === "") {
        minutes2 = cellB && cellB.substr(0, cellB.indexOf("Minutes"));
    }
    else {
        minutes2 = cellB !== null && cellB.substring(0, cellB.indexOf("Minutes")) !== "" && hours2 !== null ? cellB.trim().split("Hours").pop() : null;
    }
    let hourstoInt1 = (hours2 !== "" && parseInt(hours2 * 60));
    let minutestoInt1 = (minutes2 && minutes2 !== "" ? parseInt(minutes2) : 0);
    let total2 = hours2 !== null && hourstoInt1 !== null && minutestoInt1 !== null ? parseInt(hourstoInt1) + parseInt(minutestoInt1) : null;
    if (sortDirection.sortDirection === sortDirection.sortStates.DESC) {
        return compare(total1, total2, "desc");
    }

    return compare(total1, total2, "asc");
}
export const defaultSortRow = (cellA, cellB, sortDirection, sortStates) => {
    if (sortDirection.sortDirection === sortDirection.sortStates.DESC) {
        return compare(cellA, cellB, "desc");
    }

    return compare(cellA, cellB, "asc");

}